import { render } from "./products.vue?vue&type=template&id=f1f6f016&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"

import "./products.vue?vue&type=style&index=0&id=f1f6f016&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f6f016"]])

export default __exports__